import { ApiClient } from '@webapp/core/services/ApiClient'
import { PrimaryCategoryRepository } from './PrimaryCategoryRepository'

export const primaryCategoryRepository = new PrimaryCategoryRepository({
  httpClient: ApiClient,
})
